import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Button, Divider, Image, message, Popover, Rate, Space, Spin, Statistic, Tabs, Upload} from "antd";
import {Link, useParams} from "react-router-dom";
import MatchTable from "../MatchTable";
import {divide1toPct, getHandleNumber, getHandleNumer, globalData, setKey} from "../../util/util";
import HeroTable from "../HeroTable";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LoadingOutlined from "@ant-design/icons/lib/icons/LoadingOutlined";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import Icon from "../Icon";
import Mvp from "../Mvp";
import Svp from "../Svp";
import Max from "../Max";
import Follow from "../Follow";
import Friends from "../Friends";
import Switch from "antd/es/switch";
import Dropdown from "antd/es/dropdown";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import copy from "copy-to-clipboard"

export default () => {

    const {t} = useTranslation()
    const params = useParams()
    const handle = params.id
    const [player, setPlayer] = useState({})
    const [loading, setLoading] = useState(false)
    const [removing, setRemoving] = useState(true)
    const [star,setStar] = useState(0)
    const [names, setNames] = useState([{
        key: 1,
        label: <Spin/>
    }])

    useEffect(() => {
        if (globalData("playerHeroFlag") === "1") {
            globalData("playerHeroFlag", "0")
            window.location.reload()
        }
        if (handle) {
            axios.get(`player/info/${handle}`, {
                params: {
                    stat: 1,
                }
            }).then(res => {
                if (res) {
                    setPlayer(res)
                }
            })
            axios.get(`follow/info/${handle}`).then(res => {
                setStar(res)
            })
        }


    }, [params.id])

    const tabs = [
        {
            label: t('matches'),
            key: "matches",
            children: player.handle && <MatchTable playerHandle={player.handle} style={{  width: '900px', }} columns={['mode', 'duration', 'hero', 'kda', 'result', "score", 'endTime']} update={(pageInfo, setData) => {
                    axios.get(`game/list`,{
                        params: {
                            current: pageInfo.current,
                            pageSize: 10,
                            playerHandle: player.handle,
                        }
                    }).then(data => {
                        setKey(data.records, 'id')
                        pageInfo.total = data.total
                        pageInfo.pageSize = 10
                        setData(data.records)
                    })
                }}/>
                || null,
        },
        {
            label: t('heroes'),
            key: "heroes",
            children: <HeroTable playerHandle={player.handle} />
        },
        {
            label: t('likes'),
            key: "likes",
            children: player.handle && <MatchTable playerHandle={player.handle} style={{  width: '900px', }} columns={['region', 'mode', 'duration', 'team1', 'team2', 'score', 'endTime']} update={(pageInfo, setData) => {
                    axios.get(`game/list`,{
                        params: {
                            current: pageInfo.current,
                            pageSize: 10,
                            playerHandle: player.handle,
                            like: 1,
                        }
                    }).then(data => {
                        setKey(data.records, 'id')
                        pageInfo.total = data.total
                        pageInfo.pageSize = 10
                        setData(data.records)
                    })
                }}/>
                || null,
        },
        {
            label: t('follow'),
            key: "follow",
            children: <Follow playerHandle={player.handle} />
        },
        {
            label: t('max'),
            key: "max",
            children: <Max player={player} />
        },
        {
            label: t('friends.title'),
            key: "friends",
            children: <Friends player={player} />
        },
    ]

    const head = globalData('handle') == player.handle ?
        <Space direction={'vertical'}>
            <Popover content={t('tip7')}>
                <Switch checked={player.pfpShow} onChange={(e) => {
                    player.pfpShow = e === true ? 1 : 0
                    setPlayer({...player})
                    axios.post(`player/setShowPfp/${player.pfpShow}`).then(r => {})
                }} />
            </Popover>

            <Upload
                openFileDialogOnClick={!removing}
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={axios.defaults.baseURL + "player/uploadPfp"}
                headers={{ handleStr: localStorage.getItem('handleStr') || '' }}
                beforeUpload={(file) => {
                    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                    if (!isJpgOrPng) {
                        message.error(t('jpgOrPngErrorMsg')).then(r => {});
                    }
                    const isLt128L = file.size <= 1024 * 128;
                    if (!isLt128L) {
                        message.error(t('lt128LErrorMsg')).then(r => {});
                    }
                    return isJpgOrPng && isLt128L;
                }}
                onChange={(info) => {
                    if (info.file.status === 'uploading') {
                        setLoading(true)
                        return
                    }
                    if (info.file.status === 'done') {
                        setLoading(false)
                        if (info.file.response.code === 1) {
                            message.success(t('uploadedMsg')).then()
                            if (!player.pfp) {
                                player.pfp = 0
                            }
                            player.pfp += 1
                            setPlayer({...player})
                            let selves = globalData("selves")
                            if (selves) {
                                selves.forEach(self => {
                                    if (self.handle == player.handle) {
                                        self.pfp = player.pfp
                                    }
                                })
                                globalData("selves", selves)
                            }
                        }
                    }
                }}
            >
                {player.pfp > 0 ? (
                    <Popover title={t('tip6')} content={<Button onClick={(e) => {
                        axios.post(`player/removePfp`).then(res => {
                            let selves = globalData("selves")
                            if (selves) {
                                selves.forEach(self => {
                                    if (self.handle == player.handle) {
                                        self.pfp = 0
                                    }
                                })
                                globalData("selves", selves)
                            }
                            message.success(t('success')).then()
                            player.pfp = 0
                            setPlayer({...player})
                        })
                        return false
                    }}>{t('remove')}</Button>}>
                        <Avatar onClick={() => {
                            setRemoving(false)
                            setTimeout(() => setRemoving(true), 1000)
                        }} src={`https://www.aslucky.club/file/touhou/pfp/${player.handle}.png?r=${player.pfp}`} shape="square" size={88} icon={<UserOutlined />} />
                    </Popover>

                ) : (
                    <div onClick={() => {
                        setRemoving(false)
                        setTimeout(() => setRemoving(true), 1000)
                    }}>
                        {loading ? <LoadingOutlined /> : <PlusOutlined />}
                        <div
                            style={{
                                marginTop: 8,
                            }}
                        >
                            {t('uploadPfp')}
                        </div>
                    </div>
                )}
            </Upload>
        </Space>
        : (player.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${player.handle}.png?r=${player.pfp}`} shape="square" size={88} icon={<UserOutlined />} /> :
            <Avatar shape="square" size={88} icon={<UserOutlined />} />
    )

    return player.name &&
        <Space direction={'vertical'}>
            <Space size={30}>
                {head}
                <Space direction={'vertical'}>
                    <Space>
                        {
                            globalData('handle') != player.handle ?  <Rate style={{fontSize: "32px"}} value={star} count={1} onChange={(v) => {
                                setStar(v)
                                if (v === 1){
                                    axios.post(`follow/add/${player.handle}`).then()
                                } else if(v === 0) {
                                    axios.post(`follow/remove/${player.handle}`).then()
                                }
                            }}/> : null
                        }

                        <span style={{ fontSize: '30px', color: '#595959', }}>{player.clanTag ? `<${player.clanTag}>` : ''}{player.name}</span>
                        <Dropdown
                            menu={{
                                items: names,
                            }}
                            onOpenChange={(open) => {
                                if (open === false) {
                                    return
                                }
                                setNames([{
                                    key: 1,
                                    label: <Spin/>
                                }])
                                axios.get(`player/namesInHistory/${player.handle}`).then(res => {
                                    let list = []
                                    for (const item of res) {
                                        list.push({
                                            key: item,
                                            label: <span onClick={() => {
                                                copy(item)
                                                message.success({
                                                    content: t('tip8'),
                                                    style: {
                                                        marginTop: '20vh',
                                                    },
                                                }).then()
                                            }}>{item}</span>,
                                        })
                                    }
                                    setNames(list)
                                })
                            }}
                        >
                            <a onClick={(e) => e.preventDefault()}>
                                <DownOutlined />
                            </a>
                        </Dropdown>
                        <Icon type={'region'} name={player.region} size={24} />
                        <a target={'blank'} href={`https://sc2arcade.com/profile/${player.region}/1/${getHandleNumber(player.handle)}/`}><Image src={'https://sc2arcade.com/favicon.ico'} preview={false} /></a>

                    </Space>
                    <Space size={60} style={{ fontSize: "24px" }}>
                        <Space direction={'vertical'}>
                            <span className={'playerInfoTitle'}>{t('mmr')}</span>
                            <b style={{ color: '#ff9c6e' }}>{player.mmr == -99999 ? t('noRank') : player.mmr}</b>
                        </Space>
                        <Space direction={'vertical'}>
                            <span className={'playerInfoTitle'}>{t('wins')}</span>
                            <b style={{color: 'rgb(102, 187, 106)'}}>{player.wins}</b>
                        </Space>
                        <Space direction={'vertical'}>
                            <span className={'playerInfoTitle'}>{t('losses')}</span>
                            <b style={{color: 'rgb(255, 76, 76)'}}>{player.losses}</b>
                        </Space>
                        <Space direction={'vertical'}>
                            <span className={'playerInfoTitle'}>{t('heroListTitle.winPercentage')}</span>
                            <b>{divide1toPct(player.wins,player.wins + player.losses)}%</b>
                        </Space>
                        <Space direction={'vertical'}>
                            <Mvp/>
                            <b>{player.mvp}</b>
                        </Space>
                        <Space direction={'vertical'}>
                            <Svp/>
                            <b>{player.svp}</b>
                        </Space>
                    </Space>
                    {
                        player.gameId ? <Link style={{fontSize: "24px"}} onClick={() => {globalData("game", null)}} to={`/match/${player.gameId}`}><b>{t('playing')}</b></Link> : null
                    }
                </Space>
            </Space>

        <Tabs
            defaultActiveKey="1"
            centered
            items={tabs}
        />
    </Space> || <Spin />
}
